import { createSafeContext } from '@/util';

import type { VBaseCheckboxRadioContextValue } from './type';

const VBaseCheckboxRadioContext =
  createSafeContext<VBaseCheckboxRadioContextValue>();

export default VBaseCheckboxRadioContext;
